import request from '../request';

export function getRoles(params) {
  return request({
    url:'management/roles',
    method:'get',
    params,
  })
}

export function getPageRoles(id) {
  return request({
    url: `management/roles?page=${id}`,
    method:'get'
  })
}

export function getRolesID( id) {
  return request({
    url: `management/roles/${id}`,
    method: 'get',
  })  
}

export function storeNewRole(data) {
  return request({
    url: 'management/roles',
    method:"post",
    data,
  })
}

export function storeDeleteRole(data) {
  return request({
    url: `management/roles/${data}`,
    method: 'delete',
    data,
  })
}

export function storePutRole(data) {
  return request({
    url: `management/roles/${data.id}`, 
    method: 'put',
    data,
    
  })
}

// axios.post(http://5.182.26.64:8090/api/roles/id)
// axios.delete(------------/roles/id)